/* Mini Pop configurator — TRUE NEEDS */
(function () {
  'use strict';

  /* Kort confetti-effect vanaf een element (± 1,2 s, geen library). Uit bij 'minder beweging'. */
  function confetti(fromEl, accent) {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var r = fromEl.getBoundingClientRect();
      var cv = document.createElement('canvas');
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var W = window.innerWidth, H = window.innerHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      cv.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483647';
      document.body.appendChild(cv);
      var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
      var colors = [accent || '#E8A3A0', '#F6C945', '#7CC4A4', '#7FA8E8', '#C79BE8', '#111111'];
      var ox = r.left + r.width / 2, oy = r.top + r.height / 2, parts = [];
      for (var i = 0; i < 90; i++) {
        var a = -Math.PI / 2 + (Math.random() - 0.5) * 1.9, sp = 7 + Math.random() * 9;
        parts.push({ x: ox + (Math.random() - 0.5) * r.width * 0.6, y: oy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp,
          w: 5 + Math.random() * 5, h: 7 + Math.random() * 6, rot: Math.random() * 6.3, vr: (Math.random() - 0.5) * 0.4,
          c: colors[i % colors.length], round: Math.random() < 0.3 });
      }
      var t0 = performance.now(), DUR = 1200;
      (function frame(now) {
        var t = now - t0;
        ctx.clearRect(0, 0, W, H);
        ctx.globalAlpha = t > DUR - 300 ? Math.max(0, (DUR - t) / 300) : 1;
        parts.forEach(function (p) {
          p.vy += 0.35; p.vx *= 0.985; p.vy *= 0.985; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
          ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.fillStyle = p.c;
          if (p.round) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, 6.3); ctx.fill(); }
          else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.rot * 2)) + 1);
          ctx.restore();
        });
        if (t < DUR) requestAnimationFrame(frame); else cv.remove();
      })(t0);
    } catch (e) {}
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Foto verkleinen in de browser (max 1600 px, JPEG) voordat hij geüpload wordt.
  function compress(file, max) {
    max = max || 1600;
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var scale = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
        var w = Math.round(img.naturalWidth * scale), h = Math.round(img.naturalHeight * scale);
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0, w, h);
        c.toBlob(function (b) { URL.revokeObjectURL(url); b ? resolve(b) : reject(new Error('compress')); }, 'image/jpeg', 0.88);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('Deze foto kan niet gelezen worden. Probeer een JPG of PNG.')); };
      img.src = url;
    });
  }

  function init(root) {
    var data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    var uploadUrl = root.dataset.uploadUrl;
    var OUT = data.outfits;
    var byId = {};
    OUT.forEach(function (o) { byId[o.id] = o; });

    /* Nieuwe outfits (uit Shopify, "auto"): variantafbeelding automatisch bijsnijden, witte achtergrond
       transparant maken en de nek zoeken, zodat het hoofd in het live voorbeeld goed staat. */
    OUT.forEach(function (o) {
      if (!o.auto || !o.src) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var sc = Math.min(1, 900 / Math.max(img.naturalWidth, img.naturalHeight));
          var w = Math.round(img.naturalWidth * sc), h = Math.round(img.naturalHeight * sc);
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          var cx = cv.getContext('2d'); cx.drawImage(img, 0, 0, w, h);
          var id = cx.getImageData(0, 0, w, h), px = id.data;
          var minX = w, minY = h, maxX = -1, maxY = -1;
          for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
            var k = (y * w + x) * 4, r = px[k], g = px[k + 1], b = px[k + 2];
            if (px[k + 3] < 20 || (r > 232 && g > 232 && b > 232 && Math.max(r, g, b) - Math.min(r, g, b) < 14)) { px[k + 3] = 0; continue; }
            if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y;
          }
          if (maxX < 0) return;
          cx.putImageData(id, 0, 0);
          /* Nek = midden van de bovenste paar procent van de figuur */
          var band = Math.max(2, Math.round((maxY - minY) * 0.03)), sx = 0, n = 0;
          for (var yy = minY; yy < minY + band; yy++) for (var xx = minX; xx <= maxX; xx++) {
            if (px[(yy * w + xx) * 4 + 3] > 0) { sx += xx; n++; }
          }
          var bw = maxX - minX + 1, bh = maxY - minY + 1;
          var out = document.createElement('canvas'); out.width = bw; out.height = bh;
          out.getContext('2d').drawImage(cv, minX, minY, bw, bh, 0, 0, bw, bh);
          o.src = out.toDataURL('image/png');
          if (n) o.neck = Math.round(((sx / n) - minX) / bw * 10000) / 10000;
          render();
        } catch (e) { /* CORS of iets anders: dan gewoon de originele afbeelding */ }
      };
      img.src = o.src;
    });
    var money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: data.currency || 'EUR' });

    var optNames = data.options.map(function (n) { return String(n).toLowerCase(); });
    var idxCount = optNames.findIndex(function (n) { return n.indexOf('aantal') > -1 || n.indexOf('person') > -1; });
    var idxOutfit = optNames.findIndex(function (n) { return n.indexOf('outfit') > -1; });
    var idxSize = optNames.findIndex(function (n) { return n.indexOf('maat') > -1 || n.indexOf('size') > -1; });
    var norm = function (s) { return String(s).toLowerCase().replace(/\s+/g, ''); };

    var sizeValues = [];
    if (idxSize > -1) data.variants.forEach(function (v) { if (sizeValues.indexOf(v.options[idxSize]) < 0) sizeValues.push(v.options[idxSize]); });

    var state = { count: 1, size: sizeValues[0] || '', persons: [], busy: false };
    function person(i) {
      if (!state.persons[i]) state.persons[i] = { outfit: '', head: null, headUrl: '', headErr: '', headBusy: false, zoom: 1.15, rot: 0, px: 0, py: 0, ox: 50, oy: 35, own: null, ownUrl: '', ownErr: '', ownBusy: false };
      return state.persons[i];
    }

    var $ = function (sel) { return root.querySelector(sel); };
    var el = {
      figures: $('[data-figures]'), counts: $('[data-counts]'), uploads: $('[data-uploads]'),
      uploadCount: $('[data-upload-count]'), outfits: $('[data-outfits]'), copy: $('[data-copy]'),
      sizes: $('[data-sizes]'), atc: $('[data-atc]'), hint: $('[data-atc-hint]'),
      price: $('[data-price]'), priceFor: $('[data-price-for]'), priceWas: $('[data-price-was]'), timer: $('[data-timer]'), timerT: $('[data-timer-t]'),
    };

    function currentVariant() {
      var first = person(0).outfit;
      var want = { count: String(state.count), size: norm(state.size), outfit: first ? norm(byId[first].label) : null };
      var match = function (v, useOutfit) {
        if (idxCount > -1 && String(v.options[idxCount]) !== want.count) return false;
        if (idxSize > -1 && norm(v.options[idxSize]) !== want.size) return false;
        if (useOutfit && idxOutfit > -1 && want.outfit && norm(v.options[idxOutfit]) !== want.outfit) return false;
        return true;
      };
      return data.variants.find(function (v) { return match(v, true); }) || data.variants.find(function (v) { return match(v, false); });
    }

    /* Prijs per aantal personen: winkelwagen-regel = variant × aantal personen; de automatische kortingen
       '1 persoon' t/m '6 personen' (op aantal) brengen dat terug naar de staffelprijs. */
    var tiers = String(data.tiers || '').split(',').map(function (s) { return Math.round(parseFloat(String(s).replace(',', '.')) * 100); });
    function priceFor(v, n) {
      var was = v.price * n, t = tiers[n - 1];
      return { now: t > 0 && t <= was ? t : was, was: was };
    }

    /* Actie-timer tot promoEnd; verdwijnt vanzelf als hij verlopen is. */
    (function () {
      var daily = !!data.promoDaily;
      var end = data.promoEnd ? new Date(data.promoEnd).getTime() : NaN;
      if (!el.timer || (!daily && isNaN(end))) return;
      var pad = function (x) { return (x < 10 ? '0' : '') + x; };
      var tick = function () {
        if (daily) { var mid = new Date(); mid.setHours(24, 0, 0, 0); end = mid.getTime(); }
        var d = Math.floor((end - Date.now()) / 1000);
        if (daily && d <= 0) d += 86400;
        if (d <= 0) { el.timer.hidden = true; return false; }
        el.timer.hidden = false;
        el.timerT.textContent = pad(Math.floor(d / 3600)) + ':' + pad(Math.floor(d % 3600 / 60)) + ':' + pad(d % 60);
        return true;
      };
      if (tick()) var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000);
    })();

    // ---------- weergave ----------
    function figureHTML(p, i) {
      var o = byId[p.outfit];
      var caption = o ? o.label : 'Persoon ' + (i + 1);
      if (o && o.custom) {
        var src = p.own || '';
        return '<div class="mp-fig">' + (src
          ? '<img class="mp-fig__own" src="' + esc(src) + '" alt="Eigen outfit persoon ' + (i + 1) + '">'
          : '<img class="mp-fig__body is-ghost" src="' + esc(byId.man.src) + '" alt="">') +
          '<span class="mp-fig__cap">' + esc(caption) + '</span></div>';
      }
      var d = o || byId.man;
      var hh = d.hw / 0.82;
      var pad = ((hh - 0.025) * 100).toFixed(2) + '%';
      var head = p.head
        ? '<img src="' + esc(p.head) + '" alt="" style="' + headStyle(p) + '">'
        : '<span class="mp-fig__ph" aria-hidden="true"></span>';
      return '<div class="mp-fig"><div class="mp-fig__inner" style="padding-top:' + pad + '">' +
        '<img class="mp-fig__body' + (o ? '' : ' is-ghost') + '" src="' + esc(d.src) + '" alt="' + (o ? esc(o.label) : '') + '">' +
        '<div class="mp-fig__head" style="width:' + (d.hw * 100).toFixed(2) + '%;left:' + ((d.neck - d.hw / 2) * 100).toFixed(2) + '%">' + head + '</div>' +
        '</div><span class="mp-fig__cap">' + esc(caption) + '</span></div>';
    }

    function render() {
      var n = state.count;
      var ps = [];
      for (var i = 0; i < n; i++) ps.push(person(i));

      // live voorbeeld
      el.figures.style.setProperty('--mp-fig-w', n === 1 ? '74%' : (n === 2 || n === 4) ? '50%' : '36%');
      el.figures.innerHTML = ps.map(figureHTML).join('');

      // stap 1
      var c = '';
      for (var k = 1; k <= 6; k++) c += '<button type="button" class="mp-btn' + (k === n ? ' is-on' : '') + '" aria-pressed="' + (k === n) + '" data-count="' + k + '">' + k + '</button>';
      el.counts.innerHTML = c;

      // stap 2
      var needHead = ps.filter(function (p) { return p.outfit !== 'eigen'; });
      var done = needHead.filter(function (p) { return p.headUrl; }).length;
      el.uploadCount.textContent = needHead.length ? done + ' van ' + needHead.length : 'Niet nodig';
      el.uploads.innerHTML = ps.map(function (p, i) {
        if (p.outfit === 'eigen') {
          return '<div class="mp-up is-skip"><strong>Persoon ' + (i + 1) + '</strong><span>Eigen outfit gekozen: upload je foto mét hoofd bij stap 3</span></div>';
        }
        var inner = p.head
          ? '<span class="mp-up__face"><img src="' + esc(p.head) + '" alt="Foto persoon ' + (i + 1) + '" style="' + headStyle(p) + '"></span><strong>Persoon ' + (i + 1) + '</strong><span class="mp-link">' + (p.headBusy ? 'Uploaden…' : 'Wijzig foto') + '</span>'
          : '<span class="mp-up__icon"><svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 16V5 M7 10l5-5 5 5 M5 19h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span><strong>Persoon ' + (i + 1) + '</strong><span>Upload hoofd</span>';
        var sliders = p.head
          ? '<label class="mp-range">Inzoomen<input type="range" min="1" max="2.5" step="0.05" value="' + p.zoom + '" data-zoom="' + i + '"></label>' +
            '<label class="mp-range">Draaien<input type="range" min="-45" max="45" step="1" value="' + p.rot + '" data-rot="' + i + '"></label>' +
            '<span class="mp-drag-hint">Sleep de foto in het rondje om je gezicht te centreren</span>'
          : '';
        return '<div class="mp-up' + (p.head ? ' is-done' : '') + (p.headErr ? ' is-err' : '') + '">' +
          '<label class="mp-up__pick"><input type="file" accept="image/*" data-head="' + i + '">' + inner + '</label>' + sliders +
          (p.headErr ? '<span class="mp-err">' + esc(p.headErr) + '</span>' : '') + '</div>';
      }).join('');

      // stap 3
      el.outfits.innerHTML = ps.map(function (p, i) {
        var o = byId[p.outfit];
        var thumb = p.head ? '<span class="mp-mini"><img src="' + esc(p.head) + '" alt="" style="' + headStyle(p) + '"></span>' : '<span class="mp-mini is-empty"></span>';
        var tiles = OUT.map(function (oo) {
          var on = p.outfit === oo.id;
          var pic = oo.custom
            ? '<span class="mp-plus"><svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14 M5 12h14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></span>'
            : '<img src="' + esc(oo.src) + '" alt="" loading="lazy">';
          return '<button type="button" class="mp-tile' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-outfit="' + i + '" data-id="' + oo.id + '"><span class="mp-tile__pic">' + pic + '</span><span>' + esc(oo.label) + '</span></button>';
        }).join('');
        var own = '';
        if (p.outfit === 'eigen') {
          own = '<div class="mp-own"><label class="mp-own__pick' + (p.own ? ' is-done' : '') + '"><input type="file" accept="image/*" data-own="' + i + '">' +
            (p.own ? '<img src="' + esc(p.own) + '" alt="Eigen outfit persoon ' + (i + 1) + '">' : '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 16V5 M7 10l5-5 5 5 M5 19h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Upload foto</span>') +
            '</label><div><strong>' + (p.ownBusy ? 'Uploaden…' : p.own ? 'Foto geüpload. Klik op de foto om te wijzigen.' : 'Upload een foto van jou in je outfit, met hoofd') + '</strong>' +
            '<p>Eén foto van jezelf in je outfit, mét je hoofd erop. Net als de voorbeeld-outfits: hele lichaam recht van voren, armen gespreid, benen iets uit elkaar en een rustige achtergrond.</p>' +
            (p.ownErr ? '<span class="mp-err">' + esc(p.ownErr) + '</span>' : '') + '</div></div>';
        }
        return '<div class="mp-person"><div class="mp-person__head">' + thumb + '<strong>Persoon ' + (i + 1) + '</strong><span class="mp-muted">' + (o ? esc(o.label) : 'Nog geen outfit') + '</span></div>' +
          '<div class="mp-tiles" role="group" aria-label="Outfit voor persoon ' + (i + 1) + '">' + tiles + '</div>' + own + '</div>';
      }).join('');
      var first = byId[person(0).outfit];
      if (n > 1 && first && !first.custom) { el.copy.hidden = false; el.copy.textContent = 'Iedereen ' + first.label; }
      else el.copy.hidden = true;

      // stap 4
      el.sizes.innerHTML = sizeValues.map(function (s) {
        var on = s === state.size;
        return '<button type="button" class="mp-btn mp-btn--size' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-size="' + esc(s) + '">' + esc(String(s).replace(/(\d)cm/i, '$1 cm')) + '</button>';
      }).join('');

      // prijs + knop
      var v = currentVariant();
      if (v) {
        var pr = priceFor(v, n);
        el.price.textContent = money.format(pr.now / 100);
        if (el.priceWas) { el.priceWas.hidden = !(pr.was > pr.now); el.priceWas.textContent = money.format(pr.was / 100); }
      }
      el.priceFor.textContent = (n === 1 ? 'voor 1 persoon' : 'voor ' + n + ' personen') + (state.size ? ' · ' + String(state.size).replace(/(\d)cm/i, '$1 cm') : '');

      var missHead = needHead.length - done;
      var missOutfit = ps.filter(function (p) { return !p.outfit || (p.outfit === 'eigen' && !p.ownUrl); }).length;
      var uploading = ps.some(function (p) { return p.headBusy || p.ownBusy; });
      var ready = !missHead && !missOutfit && !uploading && v && v.available !== false && !state.busy;
      el.atc.disabled = !ready;
      el.atc.textContent = state.busy ? 'Even geduld…' : ready ? 'Toevoegen aan winkelmandje · ' + money.format(priceFor(v, n).now / 100) : 'Toevoegen aan winkelmandje';
      var parts = [];
      if (missHead) parts.push(missHead === 1 ? '1 foto' : missHead + " foto's");
      if (missOutfit) parts.push(missOutfit === 1 ? '1 outfit' : missOutfit + ' outfits');
      el.hint.textContent = uploading ? 'Foto wordt geüpload…' : (v && v.available === false) ? 'Deze combinatie is niet op voorraad.' : parts.length ? 'Nog nodig: ' + parts.join(' en ') : 'Alles klaar!';
    }

    // ---------- uploads ----------
    function upload(file, kind) {
      if (!uploadUrl) return Promise.reject(new Error('Upload is nog niet ingesteld.'));
      return compress(file).then(function (blob) {
        return fetch(uploadUrl + (uploadUrl.indexOf('?') > -1 ? '&' : '?') + 'kind=' + kind, { method: 'POST', headers: { 'Content-Type': 'image/jpeg' }, body: blob });
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j.url) throw new Error(j.error || 'Uploaden mislukt, probeer het opnieuw.');
          return j.url;
        });
      });
    }

    function handleFile(input, i, kind) {
      var f = input.files && input.files[0];
      if (!f) return;
      var p = person(i);
      var local = URL.createObjectURL(f);
      if (kind === 'hoofd') { p.head = local; p.headUrl = ''; p.headErr = ''; p.headBusy = true; }
      else { p.own = local; p.ownUrl = ''; p.ownErr = ''; p.ownBusy = true; }
      showLive(); render();
      upload(f, kind === 'hoofd' ? 'hoofd' : 'outfit').then(function (url) {
        if (kind === 'hoofd') { p.headUrl = url; p.headBusy = false; } else { p.ownUrl = url; p.ownBusy = false; }
        render();
      }).catch(function (e) {
        if (kind === 'hoofd') { p.headBusy = false; p.headErr = e.message; p.head = null; } else { p.ownBusy = false; p.ownErr = e.message; p.own = null; }
        render();
      });
    }

    // ---------- events ----------
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !root.contains(t)) return;
      if (t.dataset.count) { state.count = +t.dataset.count; showLive(); render(); }
      else if (t.dataset.outfit != null && t.dataset.id) { person(+t.dataset.outfit).outfit = t.dataset.id; showLive(); render(); }
      else if (t.hasAttribute('data-copy')) { var f = person(0).outfit; for (var i = 0; i < state.count; i++) person(i).outfit = f; render(); }
      else if (t.dataset.size) { state.size = t.dataset.size; render(); }
      else if (t.dataset.thumb) { showSlide(t.dataset.thumb); }
      else if (t.hasAttribute('data-atc')) { addToCart(); }
      else if (t.hasAttribute('data-info')) {
        var tip = document.getElementById(t.getAttribute('aria-controls'));
        if (tip) { tip.hidden = !tip.hidden; t.setAttribute('aria-expanded', String(!tip.hidden)); }
      }
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.dataset.head != null) handleFile(t, +t.dataset.head, 'hoofd');
      else if (t.dataset.own != null) handleFile(t, +t.dataset.own, 'eigen');
    });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.dataset.zoom != null) { var pz = person(+t.dataset.zoom); pz.zoom = +t.value; clampShift(pz); liveTransform(+t.dataset.zoom); }
      else if (t.dataset.rot != null) { person(+t.dataset.rot).rot = +t.value; liveTransform(+t.dataset.rot); }
    });
    // Tijdens het schuiven alleen de afbeeldingen bijwerken (geen volledige her-render).
    function headStyle(p) {
      return 'transform: ' + headTf(p) + '; object-position: ' + (p.ox == null ? 50 : p.ox) + '% ' + (p.oy == null ? 35 : p.oy) + '%';
    }
    /* Grenzen voor verschuiven zodat de foto het rondje altijd vult (transform-origin 50% 40%) */
    function clampShift(p) {
      var z = Math.max(1, p.zoom || 1);
      p.px = Math.max(-(z - 1) * 50, Math.min((z - 1) * 50, p.px || 0));
      p.py = Math.max(-(z - 1) * 60, Math.min((z - 1) * 40, p.py || 0));
    }
    function headTf(p) {
      return 'translate(' + (p.px || 0) + '%, ' + (p.py || 0) + '%) rotate(' + p.rot + 'deg) scale(' + p.zoom + ')';
    }

    /* Hoofdfoto centreren door te slepen: in het rondje bij stap 2 én op het hoofd in het live voorbeeld */
    var drag = null, dragMoved = false;
    root.addEventListener('pointerdown', function (e) {
      var box = e.target.closest('.mp-up__face, .mp-fig__head');
      if (!box || !box.querySelector('img') || !root.contains(box)) return;
      var idx = box.classList.contains('mp-up__face')
        ? Array.prototype.indexOf.call(el.uploads.children, box.closest('.mp-up'))
        : Array.prototype.indexOf.call(el.figures.querySelectorAll('.mp-fig'), box.closest('.mp-fig'));
      if (idx < 0) return;
      var p = person(idx), r = box.getBoundingClientRect();
      drag = { i: idx, x: e.clientX, y: e.clientY, px: p.px || 0, py: p.py || 0, ox: p.ox == null ? 50 : p.ox, oy: p.oy == null ? 35 : p.oy, w: r.width, h: r.height, id: e.pointerId, box: box };
      dragMoved = false;
      try { box.setPointerCapture(e.pointerId); } catch (x) {}
      e.preventDefault();
    });
    root.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!dragMoved && Math.abs(dx) + Math.abs(dy) < 4) return;
      dragMoved = true;
      var p = person(drag.i);
      var wantX = drag.px + dx / drag.w * 100, wantY = drag.py + dy / drag.h * 100;
      p.px = wantX; p.py = wantY; clampShift(p);
      /* Wat niet past bij deze zoom: het uitsnede-punt in de foto zelf verschuiven */
      p.ox = Math.max(0, Math.min(100, drag.ox - (wantX - p.px) * 1.5));
      p.oy = Math.max(0, Math.min(100, drag.oy - (wantY - p.py) * 1.5));
      p.px = Math.round(p.px * 10) / 10; p.py = Math.round(p.py * 10) / 10;
      p.ox = Math.round(p.ox * 10) / 10; p.oy = Math.round(p.oy * 10) / 10;
      liveTransform(drag.i);
    });
    var endDrag = function (e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      try { drag.box.releasePointerCapture(drag.id); } catch (x) {}
      drag = null;
    };
    root.addEventListener('pointerup', endDrag);
    root.addEventListener('pointercancel', endDrag);
    /* Na slepen niet per ongeluk de bestandskiezer openen */
    root.addEventListener('click', function (e) {
      if (dragMoved && e.target.closest('.mp-up__pick')) { e.preventDefault(); e.stopPropagation(); }
      dragMoved = false;
    }, true);

    function liveTransform(i) {
      var p = person(i);
      var tr = headTf(p);
      var figs = el.figures.querySelectorAll('.mp-fig');
      var head = figs[i] && figs[i].querySelector('.mp-fig__head img');
      var op = (p.ox == null ? 50 : p.ox) + '% ' + (p.oy == null ? 35 : p.oy) + '%';
      if (head) { head.style.transform = tr; head.style.objectPosition = op; }
      var ups = el.uploads.querySelectorAll('.mp-up');
      var face = ups[i] && ups[i].querySelector('.mp-up__face img');
      if (face) { face.style.transform = tr; face.style.objectPosition = op; }
      var minis = el.outfits.querySelectorAll('.mp-mini img');
      if (minis[i]) { minis[i].style.transform = tr; minis[i].style.objectPosition = op; }
      showLive();
    }

    function showSlide(id) {
      root.querySelectorAll('[data-slide]').forEach(function (s) {
        var on = s.dataset.slide === id;
        s.hidden = !on; s.classList.toggle('is-active', on);
        if (!on) { var v = s.querySelector('video'); if (v) v.pause(); }
      });
      root.querySelectorAll('[data-thumb]').forEach(function (b) {
        var on = b.dataset.thumb === id;
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
        /* Actieve miniatuur in beeld schuiven (mobiel: swipe-rij) */
        if (on && b.parentNode && b.parentNode.scrollWidth > b.parentNode.clientWidth) {
          var row = b.parentNode;
          row.scrollTo({ left: b.offsetLeft - row.offsetLeft - (row.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' });
        }
      });
    }
    function showLive() { showSlide('live'); }

    /* Grote afbeelding swipen met je vinger: links = volgende, rechts = vorige */
    (function () {
      var stage = root.querySelector('[data-stage]');
      if (!stage) return;
      var x0 = null, y0 = 0, t0 = 0;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1 || e.target.closest('.mp-fig__head')) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now();
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2 || Date.now() - t0 > 800) return;
        var ids = Array.prototype.map.call(root.querySelectorAll('[data-slide]'), function (s) { return s.dataset.slide; });
        var cur = root.querySelector('[data-slide].is-active');
        var i = Math.max(0, ids.indexOf(cur ? cur.dataset.slide : 'live'));
        var next = dx < 0 ? Math.min(ids.length - 1, i + 1) : Math.max(0, i - 1);
        if (next !== i) showSlide(ids[next]);
      }, { passive: true });
    })();

    function addToCart() {
      var v = currentVariant();
      if (!v) return;
      var props = { 'Aantal personen': String(state.count), _minipop: '1', _maat: state.size };
      if (state.size) props.Maat = String(state.size).replace(/(\d)cm/i, '$1 cm');
      for (var i = 0; i < state.count; i++) {
        var p = person(i), o = byId[p.outfit];
        props['Persoon ' + (i + 1)] = o.label;
        props['_p' + (i + 1) + '_outfit'] = p.outfit;
        if (p.outfit === 'eigen') props['_p' + (i + 1) + '_eigen'] = p.ownUrl;
        else {
          props['_p' + (i + 1) + '_hoofd'] = p.headUrl;
          if (o.tpl) props['_p' + (i + 1) + '_sjabloon'] = o.tpl;
          props['_p' + (i + 1) + '_zoom'] = String(p.zoom);
          props['_p' + (i + 1) + '_rotatie'] = String(p.rot);
          props['_p' + (i + 1) + '_x'] = String(p.px || 0);
          props['_p' + (i + 1) + '_y'] = String(p.py || 0);
          props['_p' + (i + 1) + '_ox'] = String(p.ox == null ? 50 : p.ox);
          props['_p' + (i + 1) + '_oy'] = String(p.oy == null ? 35 : p.oy);
        }
      }
      confetti(el.atc, getComputedStyle(root).getPropertyValue('--mp-accent').trim());
      state.busy = true; render();
      /* Secties van de cart-drawer meesturen, zodat de drawer direct ververst (zelfde aanpak als sokken-product) */
      var drawer = document.querySelector('cart-drawer-component');
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
        if (sectionIds.indexOf(c.dataset.sectionId) === -1) sectionIds.push(c.dataset.sectionId);
      });
      fetch(root.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: state.count, properties: props }], sections: sectionIds.join(','), sections_url: window.location.pathname }),
      }).then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Toevoegen mislukt'); return d; });
      }).then(function (d) {
        /* Geen cart-drawer? Dan als vanouds naar de winkelwagenpagina */
        if (!drawer || typeof drawer.open !== 'function') { window.location.href = root.dataset.cartUrl; return; }
        return fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: d, sourceId: 'minipop', data: { source: 'minipop', itemCount: cart.item_count, sections: d.sections || {} } };
          document.dispatchEvent(ev);
          if (!drawer.hasAttribute('auto-open')) setTimeout(function () { drawer.open(); }, 100);
          state.busy = false; render();
        });
      }).catch(function (e) {
        state.busy = false; render();
        el.hint.textContent = e.message || 'Er ging iets mis. Probeer het opnieuw.';
      });
    }

    render();
  }

  function boot() { document.querySelectorAll('.mp').forEach(function (r) { if (!r.dataset.ready) { r.dataset.ready = '1'; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
